/**
 * The Security Center brief's provenance line (blueprint D21, mockup 03):
 * "Assessed by Guardian at 06:12 today · 142 controls checked". Pure, so the
 * rules are unit-tested apart from React.
 *
 * Real fields only: `at` is the last Best Practice evaluation
 * (`lastEvaluatedAt`) and `controls` its checked-control count
 * (`ComplianceDashboardData.totalControls`). The count is dropped when it is
 * unknown (missing, not finite, or 0, which is what an evaluation with no
 * payload reports), and when there is no assessment to attach it to. With no
 * timestamp the line says Guardian is awaiting the first assessment, the same
 * words the Command Center uses.
 */
import { formatAssessedClock } from '@/components/common/LastAssessed'

export function assessmentProvenance(input: {
  at: string | null | undefined
  controls?: number | null
  now?: Date
}): string {
  if (!input.at) return 'Awaiting first assessment'
  const clock = formatAssessedClock(input.at, input.now)
  const lead = clock ? `Assessed by Guardian ${clock}` : 'Assessed by Guardian'
  const n = input.controls
  if (typeof n !== 'number' || !Number.isFinite(n) || n <= 0) return lead
  const count = Math.round(n)
  return `${lead} · ${count.toLocaleString('en-US')} ${count === 1 ? 'control' : 'controls'} checked`
}
